import React from 'react'
import { Card, Row, Col, Typography, Descriptions, Divider, Button, message } from 'antd'

const { Paragraph, Text } = Typography

export const CloudRecommendationResult = ({ response }: { response: any }) => {
  const r = response || {}
  const curr = r.Current || {}
  const sug = r.Suggested || {}
  const rec = r.Recommendation || {}

  const renderResourcesBlock = (obj: any) => {
    const cpuReq = obj && obj.CpuRequest != null ? `${obj.CpuRequest}m` : '-'
    const memReq = obj && obj.MemoryRequest != null ? `${obj.MemoryRequest}Mi` : '-'
    const cpuLimit = obj && obj.CpuLimit != null ? `${obj.CpuLimit}` : '-'
    const memLimit = obj && obj.MemoryLimit != null ? `${obj.MemoryLimit}Mi` : '-'
    const maxRep = obj && obj.MaxReplicas != null ? obj.MaxReplicas : '-'
    return `resources:\n  requests:\n    cpu: ${cpuReq}\n    memory: ${memReq}\n  limits:\n    cpu: ${cpuLimit}\n    memory: ${memLimit}\nmaxReplicas: ${maxRep}`
  }

  const copyToClipboard = async (text: string) => {
    try {
      if (navigator && (navigator as any).clipboard && (navigator as any).clipboard.writeText) {
        await (navigator as any).clipboard.writeText(text)
      } else {
        const ta = document.createElement('textarea')
        ta.value = text
        document.body.appendChild(ta)
        ta.select()
        document.execCommand('copy')
        document.body.removeChild(ta)
      }
      message.success('Copied to clipboard')
    } catch (e) {
      message.error('Failed to copy')
    }
  }

  return (
    <Card style={{ marginTop: 16 }} title={`${r.Cluster || ''} — ${r.Application || ''}`}>
      {r.Analysis && (
        <div style={{ marginBottom: 12 }}>
          <Paragraph>{r.Analysis}</Paragraph>
        </div>
      )}

      <Row gutter={16}>
        <Col xs={24} lg={12}>
          <Card size="small" title="Recommendations">
            <Descriptions column={1} size="small" bordered>
              <Descriptions.Item label="CPU">
                <div>
                  <Text>request: </Text>
                  <Text strong>{(rec && rec.cpu && rec.cpu.request != null) ? `${rec.cpu.request}m` : '—'}</Text>
                  {(rec && rec.cpu && rec.cpu.hpa_target_pct != null) && (<div><Text type="secondary">HPA target: {rec.cpu.hpa_target_pct}%</Text></div>)}
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="Memory">
                <div>
                  <Text>request: </Text>
                  <Text strong>{(rec && rec.memory && rec.memory.request != null) ? `${rec.memory.request}Mi` : '—'}</Text>
                  <div>
                    <Text>limit: </Text>
                    <Text strong>{(rec && rec.memory && rec.memory.limit != null) ? `${rec.memory.limit}Mi` : '—'}</Text>
                  </div>
                  {(rec && rec.memory && rec.memory.hpa_target_pct != null) && (<div><Text type="secondary">HPA target: {rec.memory.hpa_target_pct}%</Text></div>)}
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="Replicas">
                <div>
                  <Text>max replicas: </Text>
                  <Text strong>{(rec && rec.replicas && rec.replicas.max_replicas != null) ? rec.replicas.max_replicas : '—'}</Text>
                </div>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card size="small" title="Summary">
            <Paragraph>{r.SummaryForDev}</Paragraph>
          </Card>
        </Col>
      </Row>

      <Divider />

      <Row gutter={16}>
        <Col xs={24} lg={12}>
          <Card size="small" title="Current">
            <pre style={{ background: '#f6f8fa', padding: 12, borderRadius: 4, whiteSpace: 'pre-wrap' }}>{renderResourcesBlock(curr)}</pre>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card size="small" title="Suggested" extra={<Button size="small" onClick={() => copyToClipboard(renderResourcesBlock(sug))}>Copy</Button>}>
            <pre style={{ background: '#f6f8fa', padding: 12, borderRadius: 4, whiteSpace: 'pre-wrap' }}>{renderResourcesBlock(sug)}</pre>
          </Card>
        </Col>
      </Row>
    </Card>
  )
}

export default CloudRecommendationResult
